import builder from '../builder';
import SingleWoman from '../../streamline-icons/light/single-woman.svg';

export default builder('IconSingleWomanLight', SingleWoman);
